import { render, staticRenderFns } from "./risk-reward-calculator.vue?vue&type=template&id=28325e7b&scoped=true"
import script from "./risk-reward-calculator.vue?vue&type=script&lang=js"
export * from "./risk-reward-calculator.vue?vue&type=script&lang=js"
import style0 from "./risk-reward-calculator.vue?vue&type=style&index=0&id=28325e7b&prod&lang=css"
import style1 from "./risk-reward-calculator.vue?vue&type=style&index=1&id=28325e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28325e7b",
  null
  
)

export default component.exports